var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNairaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 71,
    viewBox: "0 0 80 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 20C0 8.9543 8.9543 0 20 0H60C71.0457 0 80 8.95431 80 20V51C80 62.0457 71.0457 71 60 71H20C8.9543 71 0 62.0457 0 51V20Z",
    fill: "#35B660"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 35,
    r: 20,
    fill: "#008751"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9318 32.9205H47.1591V26.5455H45.0795V32.9205H39.7955L35.3636 26.5455H33.3182V32.9205H31.5455V34.625H33.3182V36.6023H31.5455V38.3068H33.3182V44H35.4318V38.3068H41.1591L45.1136 44H47.1591V38.3068H48.9318V36.6023H47.1591V34.625H48.9318V32.9205ZM38.6108 34.625L39.983 36.6023H35.4318V34.625H38.6108ZM45.0795 34.625V36.6023H42.3523L40.9801 34.625H45.0795ZM35.4318 32.9205V30.2955H35.6023L37.4261 32.9205H35.4318ZM43.5369 38.3068H45.0795V40.2841H44.9091L43.5369 38.3068Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaw);
export default __webpack_public_path__ + "static/media/nairaw.0e31bfac.svg";
export { ForwardRef as ReactComponent };